import { Helmet } from 'react-helmet';
import NewdanhmucdangkiemDetail
  from 'src/components/newdanhmucdangkiem-detail/NewdanhmucdangkiemDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucdangkiemListToolbar from '../components/newdanhmucdangkiem-detail/NewdanhmucdangkiemToolbar';

const Newdanhmucdangkiem = () => (
  <>
    <Helmet>
      <title>Danh mục đăng kiểm</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucdangkiemListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucdangkiemDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucdangkiem;
